import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPCandidateDetailsFormLoc =
	| 'SPCandidateDetailsFormDOBLabel'
	| 'SPCandidateDetailsFormDOBErrorReq'
	| 'SPCandidateDetailsFormDOBErrorMax';

export const spCandidateDetailsFormLocs: LocDefs<SPCandidateDetailsFormLoc> = {
	SPCandidateDetailsFormDOBLabel: {
		defaultValue: 'Date of Birth',
		description: 'Label for the candidate Date of Birth Field',
		displayPath: 'Profile|Information|Date of Birth|Label',
		displayType: 'Label',
		shared: true,
		portal: 'SP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
	SPCandidateDetailsFormDOBErrorReq: {
		defaultValue: 'Date of Birth is required',
		description: 'Error displayed when candidate date of birth is not supplied',
		displayPath: 'Profile|Information|Date of Birth|Required Error',
		displayType: 'Error',
		shared: true,
		portal: 'SP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
	SPCandidateDetailsFormDOBErrorMax: {
		defaultValue: 'Date of Birth must be before today',
		description: 'Error displayed when candidate date of birth is in the future',
		displayPath: 'Profile|Information|Date of Birth|Future Error',
		displayType: 'Error',
		shared: true,
		portal: 'SP',
		feature: HubFeature.CandidateProfileDateOfBirth,
	},
};

export const LOC_KEYS = MapLocKeys<SPCandidateDetailsFormLoc>(spCandidateDetailsFormLocs);
export type SPCandidateDetailsFormLocType = LocMap<SPCandidateDetailsFormLoc>;
